import { useCallback, useRef } from 'react';

type DebouncedFunction<F extends (...args: any[]) => any> = (...args: Parameters<F>) => void;

function useDebounce<F extends (...args: any[]) => any>(fn: F, debounceMs: number): DebouncedFunction<F> {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const debouncedFn = useCallback<DebouncedFunction<F>>(
        (...args) => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            timeoutRef.current = setTimeout(() => {
                fn(...args);
            }, debounceMs);
        },
        [fn, debounceMs]
    );

    return debouncedFn;
}

export default useDebounce;
